// extracted by mini-css-extract-plugin
export default {"ModalHeader":"Modal_ModalHeader__YqNjz","ModalHeader_Title":"Modal_ModalHeader_Title__ytyJP","ModalBody":"Modal_ModalBody__jnK06"};